import help from './help';
import loadingIndicator from './loadingIndicator';
import navs from './navs';
import userSettings from './user-settings';

export default [
  help,
  loadingIndicator,
  navs,
  userSettings
];
